import { memo } from "react";
import { FormControl, FormErrorMessage, FormLabel, Skeleton } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { ReactSelectWithChakraStyle } from "../../atoms/ReactSelectWithChakraStyle";
import { useFetchSalesmen } from "../../../hooks/salesmen/useFetchSalesmen";
import { SelectOption, NoOptionsMessageProps } from '../../../types/select';

type SelectSalesmanProps = {
  control: any;
  errors: any;
}

export const SelectSalesman = memo(({control, errors}: SelectSalesmanProps) => {
  const { salesmen, isLoading } = useFetchSalesmen()
  const salesmanOption = salesmen?.map((salesman) => ({
    value: salesman.id,
    label: salesman.full_name
  }));
  const salesmanError = errors.corporation?.salesman?.message;
  return (
    <FormControl isRequired isInvalid={errors.corporation?.salesman} w='100%'>
      <FormLabel>営業担当</FormLabel>
      <Skeleton isLoaded={!isLoading} rounded='md'>
        <Controller
          name='corporation.salesman'
          control={control}
          render={({ field }) => (
            <ReactSelectWithChakraStyle<SelectOption>
              noOptionsMessage={({inputValue}: NoOptionsMessageProps) => !inputValue && '営業担当が存在しません'}
              placeholder="選択"
              options={salesmanOption}
              value={salesmanOption?.find((x) => x.value === field.value)}
              onChange={(newValue: SelectOption | null) => {
                field.onChange(newValue?.value);
              }}
              instanceId="corporation-salesman-select"
            />
          )}
        />
      </Skeleton>
      <FormErrorMessage>{salesmanError}</FormErrorMessage>
    </FormControl>
  );
});